import { render } from "./B2bTableInventoryReport.vue?vue&type=template&id=679a9c0d&scoped=true&lang=pug"
import script from "./B2bTableInventoryReport.vue?vue&type=script&lang=js"
export * from "./B2bTableInventoryReport.vue?vue&type=script&lang=js"

import "./B2bTableInventoryReport.vue?vue&type=style&index=0&id=679a9c0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679a9c0d"]])

export default __exports__